/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 08.09.2016.
 */

import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import _get from 'lodash/get';
import _at from 'lodash/at';
import _some from 'lodash/some';
import _isNil from 'lodash/isNil';
import _map from 'lodash/map';
import _size from 'lodash/size';
import _chunk from 'lodash/chunk';
import _flatten from 'lodash/flatten';
import _uniq from 'lodash/uniq';
import _isEqual from 'lodash/isEqual';

import {FetchAssetByIds} from '../../actions/asset/action-asset';
import {GetPurchases} from '../../actions/purchase/actions-purchase';
import {GetOffers} from '../../actions/collection/actions-collection';
import {OpenProfileFor} from '../../actions/common/actions-common';

import Translate from '../../components/Translate';
import DivLoader from '../../components/DivLoader';
import ShowcaseRow from '../../components/ShowcaseCollection/showcase-collection-row';

class ShowcasePurchases extends Component {
  constructor(props) {
    super(props);

    this.state = {
      extendedRow: null,
      extendedCol: null,
      extendedShowcase: null
    };
  }

  componentWillMount() {

    this.props.GetOffers();
    this.props.GetPurchases();

    this.props.FetchAssetByIds(_uniq(_flatten(_map(this.props.purchases, 'asset_id'))));
  }

  componentDidMount() {

    if (this.props.globalProfile && this.props.globalProfile !== 'purchases') {

      this._onCollapseRow();
    }
  }

  componentWillReceiveProps(newProps) {

    if (!_isEqual(_map(newProps.purchases, 'asset_id'), _map(this.props.purchases, 'asset_id'))) {

      this.props.FetchAssetByIds(_uniq(_flatten(_map(newProps.purchases, 'asset_id'))));
    } else if (_some(newProps.rentedAssets, _isNil)) {

      this.props.FetchAssetByIds(_uniq(_flatten(_map(newProps.purchases, 'asset_id'))));
    }

    if (newProps.globalProfile && newProps.globalProfile !== 'purchases') {

      this._onCollapseRow();
    }

    if (newProps.purchases.length !== this.props.purchases.length) {

      this._onCollapseRow();
    }

    if (newProps.offers.length !== this.props.offers.length) {

      this._onCollapseRow();
    }
  }

  _onExtendRow(type, row, col) {

    this.setState({extendedRow: row, extendedCol: col, extendedShowcase: type});
    this.props.OpenProfileFor('purchases');
  }

  _onCollapseRow() {

    this.setState({extendedRow: null, extendedCol: null});
  }

  _renderOfferRows() {
    if (!_size(this.props, 'offers')) {
      return null;
    }

    return _chunk(this.props.offers, '3').map((chunk, index) => {

      return <ShowcaseRow
        key={`row_${index}`}
        assets={chunk}
        row={index}
        onExtendRow={this._onExtendRow.bind(this, 'offers')}
        isExtend={this.state.extendedRow === index && this.state.extendedShowcase === 'offers'}
        sel_row={this.state.extendedRow}
        sel_col={this.state.extendedCol}
      />
    });
  }

  _renderOwnedAssetRows() {
    if (!_size(this.props, 'assets')) {
      return null;
    }

    return _chunk(this.props.rentedAssets, '9').map((chunk, index) => {
      return <ShowcaseRow
        key={`row_${index}`}
        assets={chunk}
        row={index}
        onExtendRow={this._onExtendRow.bind(this, 'owned')}
        isExtend={this.state.extendedRow === index && this.state.extendedShowcase === 'owned'}
        sel_row={this.state.extendedRow}
        sel_col={this.state.extendedCol}
      />
    });
  }

  render() {

    return (
      <div>
        <div className="asset-showcase" style={{position: 'relative'}}>
          <div id="showcase-header" className="blocks-row clearfix">
            <ul className="h-rmenu menu block col-last">
              <li className="h-rmenu-col block radius bg-black search-open">
                <a className="h-rmenu-search-link hover pointer" style={{left: 0}}>
                  <i className="ic ic-purchases ic-24px" style={{position: 'relative', top: '20px', left: '15px'}}></i>
                </a>
                <a className="pad-lr hover container pointer relative" style={{left: '63px'}}>
                  <span> <strong> <Translate content='my_services.subscriptions' /> </strong></span>
                </a>
              </li>
            </ul>
          </div>
          <div id="showcase-row-container">
            {this._renderOfferRows()}
          </div>
          { (this.props.inProgress) &&
          <div className="profile-container">
            <div id="showcase_row" style={{height: '132px', position: 'relative'}}>
              <div className="blocks-row clearfix showcase-row radius" style={{height: '100%'}}>
                <DivLoader loading={this.props.inProgress} />
              </div>
            </div>
          </div>
          }
          { (!this.props.inProgress && !_size(this.props.offers) ) && <div id="showcase-empty-container">
            <div className="ui dimmer visible active radius">
              <div className="content">
                <div className="center">
                  <h2 className="ui inverted icon header">
                    <Translate content="empty_section" />
                  </h2>
                </div>
              </div>
            </div>
          </div>
          }
        </div>
        { !!_size(this.props.rentedAssets) && <div className="asset-showcase" style={{position: 'relative'}}>
          <div id="showcase-header" className="blocks-row clearfix">
            <ul className="h-rmenu menu block col-last">
              <li className="h-rmenu-col block radius bg-black search-open">
                <a className="h-rmenu-search-link hover pointer" style={{left: 0}}>
                  <i className="ic ic-owned ic-24px" style={{position: 'relative', top: '20px', left: '15px'}}></i>
                </a>
                <a className="pad-lr hover container pointer relative" style={{left: '63px'}}>
                  <span> <strong> <Translate content="my_services.my_rents" /> </strong></span>
                </a>
              </li>
            </ul>
          </div>
          <div id="showcase-row-container">
            {this._renderOwnedAssetRows()}
          </div>
          { (this.props.inProgress) &&
          <div className="profile-container">
            <div id="showcase_row" style={{height: '132px', position: 'relative'}}>
              <div className="blocks-row clearfix showcase-row radius" style={{height: '100%'}}>
                <DivLoader loading={this.props.inProgress} />
              </div>
            </div>
          </div>}
        </div> }
      </div>
    );
  }
}

ShowcasePurchases.propTypes = {
  /**
   * @connect props
   */
  packages: PropTypes.array.isRequired,
  globalProfile: PropTypes.string,
  assets: PropTypes.array.isRequired
};

ShowcasePurchases.defaultProps = {
  /**
   * @connect props
   */
  packages: [],
  globalProfile: null,
  assets: [],
};

const mapStateToProps = ({assets, collections: {offers}, common: {profile}, purchases: {purchases, subscriptions}}) => {
  let collection = _get(offers, 'collection', []);
  let purchasedEntities = _at(assets, _uniq(_map(purchases, 'asset_id')));

  return {
    globalProfile: profile,
    offers: [...collection],
    purchases: [...purchases],
    subscriptions: [...subscriptions],
    rentedAssets: [...purchasedEntities],
    inProgress: !!offers.inProgress
  }
};

const mapDispatchToProps = (dispatch) => {

  return bindActionCreators({FetchAssetByIds, GetPurchases, GetOffers, OpenProfileFor}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(ShowcasePurchases);



// WEBPACK FOOTER //
// ./src/containers/ShowcasePurchases/showcase-purchases.js